
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/tin-tuc",
      function () {
        return require("private-next-pages/default/desktop/tin-tuc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/tin-tuc"])
      });
    }
  